import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LanguagePickerRoutingModule } from './language-picker-routing.module';
import { LanguagePickerComponent } from './language-picker.component';
import { SharedModule } from '../../shared.module';


@NgModule({
  declarations: [LanguagePickerComponent],
  imports: [
    CommonModule,
    LanguagePickerRoutingModule,
    SharedModule
  ],
  exports: [
    LanguagePickerComponent
  ]
})
export class LanguagePickerModule { }
